export const boxStyles = {
  verticalButtonGroupBox: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 4,
  },
};
